import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Hook to fetch user's top-up history (purchases + admin grants)
 * Uses user_topup_history view which combines:
 * - reedle_credit_purchases (Stripe payments)
 * - admin_credit_grants (manual admin grants)
 */
export function useTopUpHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, []);

  async function fetchHistory() {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setLoading(false);
        return;
      }

      // Query the unified view
      const { data, error } = await supabase
        .from('user_topup_history')
        .select('*')
        .eq('user_id', user.id)
        .order('transaction_date', { ascending: false })
        .limit(50);

      if (error) {
        console.error('Error fetching top-up history:', error);
        setLoading(false);
        return;
      }

      setHistory(data || []);
      setLoading(false);
    } catch (err) {
      console.error('Error in fetchHistory:', err);
      setLoading(false);
    }
  }

  return { history, loading, refresh: fetchHistory };
}

export default useTopUpHistory;

